import SolidBoltAltIcon from 'LuxKit/Icons/solid/SolidBoltAltIcon'
import InformationLabel from 'LuxKit/Label/InformationLabel'
import MessagingLabel from 'LuxKit/Label/MessagingLabel'
import BodyText from 'LuxKit/Typography/BodyText'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import useRebrandVersion from 'hooks/useRebrandVersion'
import { FormattedMessage } from 'react-intl'
import type { BookingLabelThreshold } from './urgencyLabelVisibility'
import { shouldShowBookingsCountLabel } from './urgencyLabelVisibility'

interface Props {
  /**
   * The number of bookings that have been made
   */
  bookings: number
  /**
   * The threshhold to apply to the booking counts
   * Internally this label knows what they are, you just
   * pass what type of threshold you want
   */
  threshold: BookingLabelThreshold
  /**
   * @default label
   * `text` renders inclusion-scale inline social-proof copy without a pill chrome.
   */
  presentation?: 'label' | 'text'
}

function BookingsCountLabel(props: Props) {
  const { bookings, threshold, presentation = 'label' } = props
  const isRebrand = useRebrandVersion() === 'rebrand'

  if (!shouldShowBookingsCountLabel(bookings, threshold)) {
    return null
  }

  const label = <FormattedMessage
    id="GTtJEPbhGd04RM6BiFoi"
    defaultMessage="Booked {bookingCount} times in 3 days"
    description="Information label showing recent booking count for social proof on offer tiles"
    values={{ bookingCount: <FormatDecimal value={bookings} /> }}
  />

  if (presentation === 'text') {
    const textColour = isRebrand ? 'highlight-primary-dark' : 'highlight-secondary'
    return <BodyText variant="medium" colour={textColour}>
      {label}
    </BodyText>
  }

  if (isRebrand) {
    return <InformationLabel startIcon={<SolidBoltAltIcon />}>
      {label}
    </InformationLabel>
  }

  return <MessagingLabel variant="success" startIcon={<SolidBoltAltIcon />}>
    {label}
  </MessagingLabel>
}

export default BookingsCountLabel
